/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { CircularProgress, makeStyles } from "@material-ui/core";
import { Bar } from "react-chartjs-2";
import ChartWrapper from "./chartWrapper";
import { getBaseURL } from "src/config/api";
import { useTranslation } from "react-i18next";
import safeLogger from "src/services/safeLogger";

const useStyles = makeStyles((theme) => ({
  root: {
    maxHeight: "100vh",
  },
  spinner: {
    position: "absolute",
    top: "48%",
    left: "48%",
  },
}));

function getColor(d, a1, a2) {
  return a1.map((p, i) => Math.floor(a1[i] + d * (a2[i] - a1[i])));
}

const asc = (arr) => arr.sort((a, b) => a - b);

const InsertSizeHistogramBarChart = (props) => {
  const classes = useStyles();
  const { helpInformation, files, tagSuffix } = props;
  const [sampleData, setSampleData] = useState(undefined);
  const [isBackgroundSet, setIsBackgroundSet] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    let mounted = true;
    // const re = RegExp("genome_fraction_coverage(-mother|-father|-child)?");
    // const fileTag = Object.keys(files).find((tag) => re.test(tag));
    const fileTagSuffix = tagSuffix ? "-" + tagSuffix : "";
    try {
      fetch(
        getBaseURL() +
          files["insert_size_histogram" + fileTagSuffix].download_address
      )
        .then((response) => response.text())
        .then((rawData) => {
          rawData = rawData.split("\n");
          const axisLabels = rawData[0];
          rawData = rawData.slice(1);
          const labels = []; // Insert size (bp)
          const data = []; // number of reads
          // const backgroundColor = [];
          // const hoverBackgroundColor = [];
          for (let i = 0; i < rawData.length; i += 12) {
            const row = rawData[i].split("\t");
            labels.push(parseFloat(row[0]));
            data.push(row[1]);
            // backgroundColor.push(colors[materialColors[4]][300]);
            // hoverBackgroundColor.push(colors[materialColors[4]][500]);
          }

          if (mounted) {
            setSampleData({
              labels: labels,
              datasets: [
                {
                  label: axisLabels.split("\t")[0],
                  data: data,
                  // backgroundColor: backgroundColor,
                  // hoverBackgroundColor: hoverBackgroundColor,
                },
              ],
            });
          }
        });
    } catch (e) {
      safeLogger(e);
      if (mounted) {
        setSampleData({ labels: [], datasets: [] });
      }
    }

    return function cleanup() {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (sampleData && !isBackgroundSet) {
      const backgroundColor = [];
      const hoverBackgroundColor = [];
      const data = sampleData.datasets[0].data;
      const sorted = asc(data.slice(0));
      for (let i = 0; i < data.length; i++) {
        const dataIndex = sorted.indexOf(data[i]);
        let colorOpacity = dataIndex / sorted.length;

        // colorOpacity = rangeMap(colorOpacity, 0, 1, 0.4, 0.9);
        // const hoverColorOpacity = parseFloat(colorOpacity) + 0.1;

        // backgroundColor.push(`rgba(183, 28, 28, ${colorOpacity})`);
        // hoverBackgroundColor.push(`rgba(183, 28, 28, ${hoverColorOpacity})`);

        const barColor = getColor(colorOpacity, [255, 193, 7], [244, 67, 54]);

        backgroundColor.push(`rgba(${barColor.join(",")}, 0.7)`);
        hoverBackgroundColor.push(`rgba(${barColor.join(",")}, 1)`);
      }

      sampleData.datasets[0].backgroundColor = backgroundColor;
      sampleData.datasets[0].hoverBackgroundColor = hoverBackgroundColor;
      setIsBackgroundSet(true);
      setSampleData({ ...sampleData });
    }
  }, [sampleData]);

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    title: {
      display: true,
      text: t("Insert size histogram"),
    },
    legend: { display: false },
    tooltips: {
      callbacks: {
        label: function (context) {
          return t("Number of reads") + ": " + context.yLabel;
        },
      },
    },
    scales: {
      yAxes: [
        {
          ticks: {
            stepSize: 500,
          },
          scaleLabel: {
            display: true,
            labelString: t("Number of reads"),
          },
        },
      ],
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: t("Insert size (bp)"),
          },
        },
      ],
    },
  };

  if (!sampleData) {
    return <CircularProgress className={classes.spinner} />;
  } else {
    return (
      <ChartWrapper
        title={helpInformation.label}
        helpDesc={helpInformation.description}
      >
        <Bar height={450} data={sampleData} options={options} />
      </ChartWrapper>
    );
  }
};

export default InsertSizeHistogramBarChart;
